var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__filter0_ddi_4349_36033)",
    clipPath: "url(#logo_svg__clip0_4349_36033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.874 1.157L12.572.541l-1.94 7.24L8.88 1.244l-2.302.617 1.893 7.063L3.757 4.21 2.07 5.896l5.17 5.17L.804 9.341l-.617 2.302 7.035 1.885a4.767 4.767 0 119.29-.007l6.393 1.714.617-2.303-7.063-1.892 6.44-1.726-.618-2.302-7.063 1.893 4.714-4.714-1.685-1.686-5.099 5.1 1.727-6.448z",
    fill: "url(#logo_svg__paint0_linear_4349_36033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.504 13.548a4.758 4.758 0 01-1.186 2.185l4.632 4.632 1.685-1.685-5.131-5.132z",
    fill: "url(#logo_svg__paint1_linear_4349_36033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.271 15.781a4.764 4.764 0 01-2.13 1.26l1.685 6.29 2.303-.617-1.858-6.933z",
    fill: "url(#logo_svg__paint2_linear_4349_36033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.055 17.064a4.776 4.776 0 01-2.462-.022l-1.687 6.296 2.303.617 1.846-6.891z",
    fill: "url(#logo_svg__paint3_linear_4349_36033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.512 17.019a4.766 4.766 0 01-2.093-1.278l-4.643 4.643L5.46 22.07l5.05-5.051z",
    fill: "url(#logo_svg__paint4_linear_4349_36033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38 15.7a4.756 4.756 0 01-1.155-2.158L.81 15.261l.617 2.302L8.38 15.7z",
    fill: "url(#logo_svg__paint5_linear_4349_36033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.953 17.631c.296.052.6.082.912.082.17 0 .338-.011.505-.027l-1.516 5.656-1.336-.358 1.435-5.353zm5.563 4.729l-1.337.358-1.434-5.354c.45-.172.868-.403 1.249-.685l1.522 5.68zM8.43 16.436c.357.307.755.568 1.186.771L5.46 21.363l-.978-.979 3.947-3.948zm12.497 2.243l-.977.979-3.951-3.952c.294-.372.538-.786.724-1.23l4.204 4.203zM6.882 14.151c.155.452.37.876.634 1.263L1.78 16.95l-.358-1.337 5.46-1.463zm16.027-.865l-.359 1.336-5.468-1.465c.032-.233.05-.47.05-.71a5.3 5.3 0 00-.05-.723l5.827 1.562zM6.696 11.437a5.293 5.293 0 00-.081 1.41L.798 11.29l.358-1.336 5.54 1.484zM22.285 8.96l-5.547 1.487a5.257 5.257 0 00-.722-1.24l5.91-1.583.359 1.336zm-14.422.064a5.27 5.27 0 00-.768 1.188L2.78 5.896l.977-.979 4.107 4.107zM19.224 4.19L15.113 8.3a5.26 5.26 0 00-1.235-.722l4.368-4.367.978.979zM10.04 7.504c-.45.167-.87.393-1.253.67L7.19 2.213l1.336-.358 1.514 5.648zM14.26 1.51l-1.538 5.74a5.305 5.305 0 00-1.42-.04l1.622-6.057 1.336.357z",
    stroke: "#000",
    strokeOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint0_linear_4349_36033",
    x1: 11.854,
    y1: 0.866,
    x2: 11.854,
    y2: 23.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint1_linear_4349_36033",
    x1: 11.854,
    y1: 0.866,
    x2: 11.854,
    y2: 23.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint2_linear_4349_36033",
    x1: 11.854,
    y1: 0.866,
    x2: 11.854,
    y2: 23.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint3_linear_4349_36033",
    x1: 11.854,
    y1: 0.866,
    x2: 11.854,
    y2: 23.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint4_linear_4349_36033",
    x1: 11.854,
    y1: 0.866,
    x2: 11.854,
    y2: 23.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint5_linear_4349_36033",
    x1: 11.854,
    y1: 0.866,
    x2: 11.854,
    y2: 23.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__clip0_4349_36033"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__filter0_ddi_4349_36033",
    x: -32.219,
    y: -13.862,
    width: 88.145,
    height: 88.225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0784314 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4349_36033"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.003
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.136422 0 0 0 0 0.139603 0 0 0 0 0.149148 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4349_36033",
    result: "effect2_dropShadow_4349_36033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4349_36033",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.601
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect3_innerShadow_4349_36033"
  })))));
}
export default SvgLogo;